// extracted by mini-css-extract-plugin
export default {"root":"D_vxKJ","canvas":"OlQoIZ","link":"TtTdZE","spreadAreaBorder":"imh9ip","selectableText":"RwE4JJ","reducedMotion":"EeuwKE","hidden":"OJ_bej"};